<template>
      <card>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :staticFilters="staticFilters"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :filters="filters"
          :searchDisable="false"
          :exportsData="exportsData"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      filters: [
        {
          key: "shop",
          title: "Фильтр по торговым точкам",
          titleKey:'name'
        },
        {
          key: "user",
          title: "Фильтр по кураторам",
          titleKey:'phone',
          params:{role_code:'tp_admin'},
        },
      ],
      staticFilters: [
        {
          title: "Активность:",
          key: "is_active",
          default: null,
          items: [
            { 
                id:null,
                title:"Показать всех"
            },
            {
              id: "2",
              title: "Активные",
            },
            {
              id: "1",
              title: "Не активные",
            }
          ],
        },
        
        ],
      val: [],
      modalCreate: "dealer",
      fields: [
        {
        col:' col-12 col-md-9',
        key: "phone",
        label: "Номер телефона",
        type: "mask",
        mask:'+998#########',
        placeholder:'+998'

      },
    
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_dealer",
      exportsData: [
        {
          type: "export-all",
          url: '/dealers/export-all',
          url_import: '/dealers/import-all',
          name: 'Бизнесы_база'
        }
      ],
      itemLink: "dealers",
      setLink: "dealers",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy:'id'
        },
        {
          key: "llc_name",
          title: "Название оргранизации",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "first_name",
          title: "Имя",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "last_name",
          title: "Фамилия",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
    
        {
          key: "is_active",
          title: "Активность",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
